import { CustomizationView } from "./customization-view";
import React from "react";
import { TCustomizationSelection } from "constants/product-customizations/customization-selection.types";
import { makeStyles } from "@material-ui/core";
import { CUSTOMIZATIONS } from "constants/integration/customizations";
interface IProps {
    customizations: TCustomizationSelection[];
}

export const CustomizationsView: React.FC<IProps> = ({ customizations }) => {
    const classes = useStyles();
    return (
        <div className={classes.customizationsContainer} data-test={CUSTOMIZATIONS.PRODUCT_CUSTOMIZATIONS_CONTAINER}>
            {customizations.map((customization, index) => (
                <CustomizationView customization={customization} key={index} />
            ))}
        </div>
    );
};

const useStyles = makeStyles({
    customizationsContainer: {
        margin: "12px 0",
    },
});
